export const setAuthEmail = (email: string) => {
  try {
    localStorage.setItem("auth_email", email);
  } catch {}
};

export const getAuthEmail = () => {
  try {
    return localStorage.getItem("auth_email") || "";
  } catch {
    return "";
  }
};

export const clearAuthEmail = () => {
  try {
    localStorage.removeItem("auth_email");
  } catch {}
};
